'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"tab-nav":"Tabs-module_tab-nav__27sG1","tab-button":"Tabs-module_tab-button__-6BvY","tab-button-text":"Tabs-module_tab-button-text__d1BiQ","tab-button-list-item":"Tabs-module_tab-button-list-item__eEVwT","active":"Tabs-module_active__Eclqm","two-tabs":"Tabs-module_two-tabs__pYudZ"};

exports.default = styles;
//# sourceMappingURL=Tabs.module.scss.js.map
